'use strict';

(function () {
  'use strict';

  angular.module('referrals').directive('referralAccessCodeValidator', referralAccessCodeValidator);

  referralAccessCodeValidator.$inject = ['$timeout', '$q', '$http', '$stateParams'];

  function referralAccessCodeValidator($timeout, $q, $http, $stateParams) {
    var timeout, deferred;

    /**
     * Validates the passed in accessCode is within the scope of the current
     * provider giving context.
     * @param       {String} accessCode The access code short name
     * @constructor
     * @return      {Promise}            A promise of validation
     */
    function _validate(accessCode) {
      accessCode = accessCode.replace(/\//g, '');
      //accessCode validation uses the existing customSignUp API endpoint
      //to ensure the access code is within the current scope.
      var url = '/apiproxy/collateral/signups/';
      if ($stateParams.group) {
        url += 'groups/' + $stateParams.group + '/accesscodes/' + accessCode;
      } else if ($stateParams.organization) {
        url += 'organizations/' + $stateParams.organization + '/accesscodes/' + accessCode;
      } else {
        url += 'accesscodes/' + accessCode;
      }
      return $http.get(url + '?include=group&include=organization');
    }

    /**
     * The link function for this directive.  Creates the validation function
     * that will asynchronously validate accessCodes while the user is typing
     * them into the text input on the page.
     * @param       {Object} scope The current scope of the directive
     * @param       {Object} elem  The DOM element to validate
     * @param       {String} attr  DOM attributes on the directive element
     * @param       {Object} ctrl  The controller containing the accessCode being validated
     * @constructor
     */
    function _link(scope, elem, attr, ctrl) {
      ctrl.$asyncValidators.accessCodeChoice = function (value) {
        if (!value) {
          return $q.when(true);
        }
        deferred = $q.defer();
        $timeout.cancel(timeout);
        // wait 0.5 seconds before attempting to resolve the code
        timeout = $timeout(function () {
          _validate(value).then(function () {
            // if successful we tell the user right away
            deferred.resolve();
          }, function () {
            // if the code failed, we give them an extra 1s to keep typing
            timeout = $timeout(function () {
              deferred.reject();
            }, 1000);
          });
        }, 500);
        return deferred.promise;
      };
    }

    return {
      transclude: true,
      restrict: 'A',
      require: 'ngModel',
      link: _link
    };
  }
})();